var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ph-ignore-input ph-no-capture",class:{
    'border-vanilla-200': _vm.cardInputFocus,
    'border-slate-400': !_vm.cardInputFocus
  },attrs:{"id":"card-input-container"}})
}
var staticRenderFns = []

export { render, staticRenderFns }